import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Component({
    selector   : 'footer',
    templateUrl: './footer.component.html',
    styleUrls  : ['./footer.component.scss']
})
export class FooterComponent implements OnInit
{
    languages: any;
    selectedLanguage: any;
    /**
     * Constructor
     */
    constructor(
        private _translateService: TranslateService
    )
    {
        this.languages = [
            {
                id   : 'en',
                title: 'English',
                flag : 'us'
            }
            ,
            {
                id   : 'br',
                title: 'Português',
                flag : 'br'
            }
            ,
            {
                id   : 'es',
                title: 'Español',
                flag : 'es'
            }
        ];
    }

    ngOnInit(): void
    {
        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, {'id': this._translateService.currentLang});
    }

    setLanguage(lang): void
    {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }
}
